const SET_APP_EVENTS_DATA: string = 'SET_APP_EVENTS_DATA';
const SET_INITIAL_DATA: string = 'SET_INITIAL_DATA';
const SET_FILTERS_DATA: string = 'SET_FILTERS_DATA';
const UPDATE_EVENT_COMMENTS: string = 'UPDATE_EVENT_COMMENTS';

export const ACCOUNT_ACTIVITY_ACTION_TYPES = {
    SET_APP_EVENTS_DATA,
    SET_INITIAL_DATA,
    SET_FILTERS_DATA,
    UPDATE_EVENT_COMMENTS,
};
